module.exports = __webpack_public_path__ + "9ba379e106bd766b5333da5651cd778f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/ucenter/order_fail.png
// module id = 508
// module chunks = 0 1